export const comparisonChart = () => {
  const chartGroups = Array.from(
    document.querySelectorAll('.comparison-charts'),
  )

  const chartContainers = Array.from(
    document.querySelectorAll('.comparison-chart__outer'),
  )

  chartGroups.forEach((group) => {
    const tabs = Array.from(
      group.querySelectorAll('.comparison-charts__tabs button'),
    )

    const charts = Array.from(
      group.querySelectorAll('.comparison-chart__outer'),
    )

    tabs.forEach((button, index) => {
      button.addEventListener('click', () => {
        tabs.forEach((b) => b.classList.remove('active'))
        charts.forEach((c) => c.classList.remove('active'))

        button.classList.add('active')
        charts[index].classList.add('active')

        setShadows(
          charts[index],
          charts[index].querySelector('.comparison-chart'),
        )
      })
    })
  })

  chartContainers.forEach((element) => {
    const container = element.querySelector('.comparison-chart')
    const outerWidth = container.clientWidth

    if (outerWidth > 0) {
      setShadows(element, container)
    }

    container.addEventListener('scroll', () => {
      setShadows(element, container)
    })
  })

  window.addEventListener('resize', () => {
    chartContainers.forEach((element) => {
      const container = element.querySelector('.comparison-chart')

      setShadows(element, container)
    })
  })
}

function setShadows(outer, element) {
  const leftShadow = outer.querySelector('.shadow--left')
  const rightShadow = outer.querySelector('.shadow--right')

  const outerWidth = element.clientWidth
  const innerWidth = element.getElementsByTagName('table')[0].clientWidth
  const difference = innerWidth - outerWidth

  if (innerWidth > outerWidth) {
    const amountScrolled = element.scrollLeft

    if (amountScrolled > 0) {
      leftShadow.classList.add('show')
    } else {
      leftShadow.classList.remove('show')
    }

    if (amountScrolled < difference) {
      rightShadow.classList.add('show')
    } else {
      rightShadow.classList.remove('show')
    }
  } else {
    leftShadow.classList.remove('show')
    rightShadow.classList.remove('show')
  }
}
